import { useCurrentDataStore } from 'components/DataStoreReference/DataStoreReference';
import React, { Suspense, ReactNode, memo } from 'react';

import SimpleLoading from 'root/SimpleLoading';
import { useStoreBusy } from 'store/useAppStore';

function SuspenseItemInner({
  name,
  children = null,
}: {
  name: string;
  children?: ReactNode;
}) {
  const store = useCurrentDataStore();
  useStoreBusy(store);
  store?.readData();
  return <>{children}</>;
}

export function SuspenseItem({
  name,
  children,
}: {
  name: string;
  children: ReactNode;
}) {
  return (
    <Suspense
      // @ts-ignore unstable_avoidThisFallback
      // eslint-disable-next-line react/jsx-boolean-value
      unstable_avoidThisFallback={true}
      fallback={<SimpleLoading name={name} />}
    >
      <SuspenseItemInner name={name}>{children}</SuspenseItemInner>
    </Suspense>
  );
}

function Suspender({ name }: { name: string }) {
  // moving the suspense from DataGrid to inner most component to avoid unmounting
  // the grid which is resetting the scroll position as the body.scrollHeight is
  // becoming zero when suspended
  return (
    <Suspense
      // @ts-ignore unstable_avoidThisFallback
      // eslint-disable-next-line react/jsx-boolean-value
      unstable_avoidThisFallback={true}
      fallback={<SimpleLoading name={name} />}
    >
      <SuspenseItemInner name={name} />
    </Suspense>
  );
}

export default memo(Suspender);
